import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { PAGE_BREAKPOINTS } from '../../../../../../constants/commonConstants';
import { useBreakpoint } from '../../../../../../hooks';
import cx from 'classnames';
import { ComponentLoaderProps } from '../../../types';

export const ComponentLoader = ({ classname }: ComponentLoaderProps) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const loaderCount = !isMD
    ? Array.from({ length: 4 }, (_, index) => index)
    : Array.from({ length: 6 }, (_, index) => index);

  return (
    <div className={cx(classname, 'w-100')}>
      <div className="mb-4">
        <CatSkeleton width="305px" />
      </div>
      {loaderCount.map((loaderKey) => {
        return (
          <div key={`component-loader-${loaderKey}`} className="mb-2 w-100">
            <CatSkeleton size="lg" />
          </div>
        );
      })}
    </div>
  );
};

export default ComponentLoader;
